import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Heading } from 'chaser-components';
import style from './UsersHeader.module.scss';

export default () => (
  <Container className={style.usersContainer}>
    <Row className={style.usersRow}>
      <Col md="6">
        <Heading>Users</Heading>
      </Col>
    </Row>
  </Container>
);
